import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { isEmpty } from 'lodash-es';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { EquipmentInstallationsResponse, GeneralManagementApi } from '@vi-iot/client';

import { InstallationsSearchActions } from './installations-search.actions';

@Injectable()
export class InstallationsSearchEffects {
  listInstallationsSearchResult$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(InstallationsSearchActions.listInstallationsSearchResult),
      switchMap((action) =>
        this.generalManagementApi
          .getInstallationsCollection({
            gatewaySerial: action.gatewaySerial,
            deviceBoilerSerial: action.boilerSerial,
            limit: action.limit,
            includeGateways: true,
          })
          .pipe(
            map((response: EquipmentInstallationsResponse) => {
              if (response.data == null) {
                response.data = [];
              }

              return InstallationsSearchActions.listInstallationsSearchResultSuccess({
                payload: response,
              });
            }),
            catchError(() => of(InstallationsSearchActions.listInstallationsSearchResultError()))
          )
      )
    );
  });

  listInstallationsSearchFetchMore$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(InstallationsSearchActions.listInstallationsSearchFetchMore),
      switchMap((action) =>
        this.generalManagementApi
          .getInstallationsCollection({
            gatewaySerial: action.gatewaySerial,
            deviceBoilerSerial: action.boilerSerial,
            cursor: action.cursor,
            limit: action.limit,
            includeGateways: true,
          })
          .pipe(
            map((response: EquipmentInstallationsResponse) => {
              if (isEmpty(response)) {
                throw new Error('Empty response');
              }

              if (!response.data) {
                response.data = [];
              }

              return InstallationsSearchActions.listInstallationsSearchFetchMoreSuccess({
                payload: response,
              });
            }),
            catchError(() => of(InstallationsSearchActions.listInstallationsSearchFetchMoreError()))
          )
      )
    );
  });

  constructor(private actions$: Actions, private generalManagementApi: GeneralManagementApi) {}
}
